import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { ChcpFederationPartialState } from './chcp-federation.reducer';
import { saveBrighterFederationPartnerData } from './chcp-federation.actions';

@Injectable({
  providedIn: 'root',
})
export class ChcpFederationFacade {
  constructor(private store$: Store<ChcpFederationPartialState>) {}

  saveBrighterFederationPartnerData() {
    this.store$.dispatch(saveBrighterFederationPartnerData());
  }
}
